<script setup>
defineProps({
  modelValue: { type: String, default: 'i-lucide-folder' },
});

const emit = defineEmits(['update:modelValue']);

const ICONS = [
  'i-lucide-megaphone',
  'i-lucide-link',
  'i-lucide-tag',
  'i-lucide-star',
  'i-lucide-briefcase',
  'i-lucide-target',
  'i-lucide-bar-chart',
  'i-lucide-users',
  'i-lucide-mail',
  'i-lucide-phone',
  'i-lucide-globe',
  'i-lucide-dollar-sign',
  'i-lucide-calendar',
  'i-lucide-file-text',
  'i-lucide-settings',
  'i-lucide-map-pin',
  'i-lucide-shopping-cart',
  'i-lucide-zap',
  'i-lucide-heart',
  'i-lucide-layers',
];
</script>

<template>
  <div class="grid grid-cols-5 gap-2">
    <button
      v-for="icon in ICONS"
      :key="icon"
      type="button"
      class="w-10 h-10 flex items-center justify-center rounded-lg border transition-colors"
      :class="
        modelValue === icon
          ? 'border-n-brand bg-n-alpha-2 text-n-brand'
          : 'border-n-weak text-n-slate-10 hover:bg-n-alpha-1 hover:text-n-slate-12'
      "
      @click="emit('update:modelValue', icon)"
    >
      <span class="size-5" :class="icon" />
    </button>
  </div>
</template>
